import React from 'react';
import '../styles/spinner.css';

const Spinner = ({message}) => (
    <div className="spinner-overlay">
        <div className="spinner"></div>
        {message ? <div className="spinner-message">{message}</div> : <h1>Loading...</h1>}
    </div>
);

export default Spinner;